<template>
  <v-dialog v-model="show" persistent :max-width="'600px'">
    <v-card class="confirm-popup">
      <v-card-title>
        <span class="headline">Suppression des lignes</span>
      </v-card-title>
      <v-card-text>
        Ceci supprimera l'ensemble des lignes enregistrées pour cet onglet, voulez vous
        poursuivre?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2 scdf-green" text @click="yesChoiceModal"> Oui </v-btn>
        <v-btn class="mr-2 scdf-red" text @click="noChoiceModal"> Non </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },

  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    yesChoiceModal() {
      this.$emit('close', {
        confirm: true,
      });
    },
    noChoiceModal() {
      this.$emit('close', {
        confirm: false,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.confirm-popup {
  .v-card__title {
    padding: 26px 24px 10px !important;
  }
  .v-card__text {
    padding: 10px 24px 26px !important;
    white-space: pre-line;
  }
}
</style>